/* eslint-disable */
// @ts-nocheck
import * as React from 'react';
import CompareBy from './CompareBy';
import FilterRows from './FilterRows';
import { GranularitySelector, HoverButton, Tooltip } from '../../core';
import type { Filters } from '../../../../main/types/druidTypes';
import { generateCsvExportModalOpenPathName } from '../../../../main/services/CsvExportQueryService';
import { selectLightweightFiltersEnabled } from '../../../../main/components/analytics/LightweightStickyBar/LightweightFilters.selectors';
import { connect } from 'react-redux';
import { ImageService } from '../../../../main/services/ImageService/ImageService';

/**
 * PureQueryBuilder: A component that provides the User Interface for constructing a Cenarius Query via the Dashboard.
 * DruidQueryBuilder differs from PureQueryBuilder because it is stateful and contains logic that is specific to constructing queries on pages where a query builder must appear stacked above a timeseries or table (e.g. ScreenAdsAnalytics, ScreenEmailAnalytics).
 * Since the User Interface for constructing queries should be independent of where and how it is used, PureQueryBuilder was implemented.
 * The use case was cheifly to place a query builder in a modal (e.g. Cohorts).
 */
type Props = {
  dimensions: Array<string>;
  eventSelect?: React.ReactElement<any>;
  cohortSelect?: React.ReactElement<any>;
  fraudSelect?: React.ReactElement<any>;
  hideCompareBy?: boolean;
  styleVariant?: string;
  dimensionsToCompareBy: Array<string>;
  dimensionsToFilterBy: Array<string>;
  maxDimensions: number;
  minDimensions: number;
  filter?: Record<string, any>;
  requiredFilter?: Record<string, any>;
  allFilters: Filters;
  unique?: boolean;
  updateUnique?: () => void;
  disableUniqueToggle?: boolean;
  organic?: boolean;
  updateOrganic?: () => void;
  disableOrganicToggle?: boolean;
  hasExportButton?: boolean;
  hasUniqueToggle?: boolean;
  hasOrganicToggle?: boolean;
  hasFraudDescriptionToggle?: boolean;
  hasSplitSkanDataToggle?: boolean;
  splitSkanData?: boolean;
  updateSkanSplit?: (arg0: Record<string, any>) => void;
  showFraudDescription?: boolean;
  toggleFraudDescription?: (arg0: Record<string, any>) => void;
  testid: string;
  updateQuery: (arg0: Record<string, any>) => void;
  title?: string;
  tooltip?: string | React.ReactElement<any>;
  updateFraudTypeOnCompareByChange?: () => void;
  customLabelMap?: Record<string, any>;
  createFilterValues?: boolean;
  fetchFilters: (arg0: string) => void;
  recordLimit?: number;
  updateGranularity?: (arg0: Record<string, any>) => void;
  granularity?: string;
  updateBlockedEventIndicator?: (arg0: string) => void;
  context?: string;
  query?: Record<string, any>;
  runFullReportButton?: React.ReactElement<any>;
  namespace?: string;
  lightweightFiltersEnabled: boolean;
};

class PureQueryBuilder extends React.PureComponent<Props> {
  renderTitle = () => {
    const props = this.props;

    if (!props.title) {
      return null;
    }

    if (props.tooltip) {
      return (
        <div className="analytics__title">
          <Tooltip body={props.tooltip}>{props.title}</Tooltip>
        </div>
      );
    }

    return <div className="analytics__title">{props.title}</div>;
  };

  shouldShowGranularitySelector = () => {
    const { context } = this.props;
    const isTableContext = context && context.endsWith('table');
    const isTimeSeriesContext = context && context.endsWith('series');
    return isTableContext || isTimeSeriesContext;
  };

  render() {
    const props = this.props;
    return (
      <div className="analytics-filters__wrapper">
        {props.cohortSelect &&
          React.cloneElement(props.cohortSelect, {
            updateQuery: props.updateQuery,
          })}
        {this.renderTitle()}
        <div className="analytics-filters">
          {props.fraudSelect &&
            React.cloneElement(props.fraudSelect, {
              dimensions: props.dimensions,
              updateQuery: props.updateQuery,
            })}
          <div className="analytics-filters__row">
            {props.eventSelect &&
              React.cloneElement(props.eventSelect, {
                updateQuery: props.updateQuery,
              })}
            {!props.hideCompareBy && (
              <CompareBy
                allFilters={props.allFilters}
                dimensions={props.dimensions}
                dimensionsToDisplay={props.dimensionsToCompareBy}
                maxDimensions={props.maxDimensions}
                minDimensions={props.minDimensions}
                updateFraudTypeOnCompareByChange={props.updateFraudTypeOnCompareByChange}
                updateQuery={props.updateQuery}
                customLabelMap={props.customLabelMap}
                recordLimit={props.recordLimit}
                context={props.context}
                granularity={props.granularity}
                query={props.query}
                organic={props.organic}
              />
            )}
            {props.runFullReportButton || null}
            {props.lightweightFiltersEnabled && this.shouldShowGranularitySelector() && (
              <GranularitySelector
                updateGranularity={props.updateGranularity}
                granularity={props.granularity}
                context={props.context}
              />
            )}
            {props.lightweightFiltersEnabled && props.hasExportButton && (
              <div className="download-csv-button">
                <HoverButton
                  to={generateCsvExportModalOpenPathName(window.location)}
                  textShownOnHover="Download CSV"
                  activeChild={<img src={ImageService.getImageUrl('/static/images/ic_download_active.svg')} />}
                  size="no-miw"
                  type="secondary"
                  className="icon-hover-button"
                  i13nModel={{
                    label: 'export to csv',
                  }}
                  testid={`${props.testid}__download-csv`}
                >
                  <img src={ImageService.getImageUrl('/static/images/ic_download.svg')} />
                </HoverButton>
              </div>
            )}
          </div>
          {!props.lightweightFiltersEnabled && (
            <FilterRows
              allFilters={props.allFilters}
              requiredFilter={props.requiredFilter}
              filter={props.filter}
              fetchFilters={props.fetchFilters}
              unique={props.unique}
              updateUnique={props.updateUnique}
              disableUniqueToggle={props.disableUniqueToggle}
              organic={props.organic}
              updateOrganic={props.updateOrganic}
              disableOrganicToggle={props.disableOrganicToggle}
              hasFraudDescriptionToggle={props.hasFraudDescriptionToggle}
              showFraudDescription={props.showFraudDescription}
              toggleFraudDescription={props.toggleFraudDescription}
              hasExportButton={props.hasExportButton}
              testid={props.testid}
              hasUniqueToggle={props.hasUniqueToggle}
              hasOrganicToggle={props.hasOrganicToggle}
              hasSplitSkanDataToggle={props.hasSplitSkanDataToggle}
              splitSkanData={props.splitSkanData}
              updateSkanSplit={props.updateSkanSplit}
              dimensionsToDisplay={props.dimensionsToFilterBy}
              updateQuery={props.updateQuery}
              customLabelMap={props.customLabelMap}
              createFilterValues={props.createFilterValues}
              updateGranularity={props.updateGranularity}
              granularity={props.granularity}
              updateBlockedEventIndicator={props.updateBlockedEventIndicator}
              context={props.context}
              dimensions={props.dimensions}
              styleVariant={props.styleVariant}
              namespace={props.namespace}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  lightweightFiltersEnabled: selectLightweightFiltersEnabled(state, props.namespace),
});

const ConnectedPureQueryBuilder = connect(mapStateToProps)(PureQueryBuilder);
export default ConnectedPureQueryBuilder;
